import { render } from "@/components/pages/individualWorkSupport/requirement135/Requirement135.html?vue&type=template&id=115b4ec8&scoped=true&external"
import script from "@/components/pages/individualWorkSupport/requirement135/Requirement135.js?vue&type=script&lang=js&external"
export * from "@/components/pages/individualWorkSupport/requirement135/Requirement135.js?vue&type=script&lang=js&external"

import "@/components/pages/individualWorkSupport/requirement135/Requirement135.scss?vue&type=style&index=0&id=115b4ec8&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-115b4ec8"]])

export default __exports__